import React, { createContext, useContext } from 'react';
import useDarkwebHook from '../../hooks/Dashboard/useDarkweb';

export const DarkwebContext = createContext();

export const DarkwebProvider = ({ children }) => {
  const web = useDarkwebHook(); // Import everything from the hook

  return (
    <DarkwebContext.Provider value={web}>
      {children}
    </DarkwebContext.Provider>
  );
};

export const useDarkweb = () => useContext(DarkwebContext);